<template>
  <!-- 要客通 -->
  <div class="guestPass full-height guestPass-banner">
    <ld-header
      @click-left="back"
      transparent
      white
    >
      <img
        slot="left"
        class="custom-back"
        src="~Assets/images/back.png"
      >
    </ld-header>

    <div class="guestpasswrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div class="list">
          <div class="box">
            <!-- <div class="list">
              <span class="font16 font-bold">要客通</span>
            </div> -->
            <div class="top">
              &nbsp;
            </div>
            <van-field
              label="机场"
              placeholder="请选择机场"
              :value="`${cityName} ${serverAirportName}`"
              is-link
              @click="$refs.city.toggle()"
              input-align="left"
              :readonly="true"
            />

            <van-field
              label="服务类型"
              is-link
              readonly
              @click="showCardType=!showCardType"
              v-model="serverTypeName"
            />
            <van-action-sheet
              description="选择服务类型"
              cancel-text="取消"
              v-model="showCardType"
              :actions="serverTypeData"
              @select="cardTypeSelect"
            />

            <van-field
              label="航班类型"
              v-model="flightTypeName"
              is-link
              @click="showFlightType = !showFlightType"
              input-align="left"
              readonly
            />
            <van-action-sheet
              description="选择航班类型"
              cancel-text="取消"
              v-model="showFlightType"
              :actions="flightTypeData"
              @select="selFlightType"
            />
          </div>

          <div
            v-for="(item,index) in detail"
            :key="item.id"
            class="box"
            @click.stop="confirm(index)"
          >
            <van-cell>
              <van-row
                type="flex"
                align="center"
              >
                <van-col span="18">
                  <span class="font-bold font16"> {{ item.serviceName }} </span>&nbsp;&nbsp;
                  <van-tag
                    size="medium"
                    round
                    plain
                    @click.stop="showExplain(item)"
                  >
                    特别声明
                  </van-tag>
                </van-col>
                <van-col
                  span="6"
                  class="text-right red"
                >
                  <span v-show="item.pricingModel==1">
                    ￥{{ (item.salePrice+item.serviceFee) }}
                  </span>
                  <span v-show="item.pricingModel==2">
                    ￥{{ (item.baseSalesPrice||0)+ (item.salePrice+item.serviceFee) }}
                  </span>
                </van-col>
              </van-row>
            </van-cell>
            <!--  -->
            <van-grid
              column-num="3"
              icon-size="34"
              class="bg-white"
              :border="false"
            >
              <van-grid-item
                v-for="value in item.apFaceilitiesBeanList" 
                :key="value.id"
                to="/guestPass/confirm"
                :icon="value.image"
                :text="value.facilityName"
              />
            </van-grid>
          </div>
        </div>
      </mescroll-vue>
    </div>

    <!--  -->
    <ld-tabbar
      ref="tabbar"
      class="bg-white shadow"
    >
      <van-row
        class="full-width"
        type="flex"
        align="center"
        gutter="8"
        justify="center"
      >
        <van-col
          span="22"
        >
          <ld-button
            main
            size="md"
            @click.native="book"
          >
            预约
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!-- 机场 -->
    <city
      ref="city"
      @selected="cityChange"
      cplx="10917"
      :city-type="0"
      hot-span="8"
      history-span="8"
      :cityjczd-name="true"
    />
    <van-popup
      v-model="showPopup"
      class="popup-width"
      closeable
      :close-on-popstate="true"
    >
      <van-cell>特别声明</van-cell>
      <van-cell>
        {{ guestsExplain }}
      </van-cell>
    </van-popup>
    <!--  -->
    <van-popup
      v-model="showList"
      position="bottom"
      closeable
      :close-on-popstate="true"
    >
      <van-cell>
        <div class="text-center">
          请选择服务
        </div>
      </van-cell>
      <van-radio-group v-model="radio">
        <van-radio
          v-for="(info,index1) in detail"
          :key="index1"
          :name="index1"
          class="list"
        >
          <van-row class="full-width">
            <van-col
              span="12"
              class="font-bold"
            >
              {{ info.serviceName }}
            </van-col>
            <van-col
              span="12"
              class="text-right money-color"
            >
              <span v-show="info.pricingModel==1">
                ￥{{ (info.salePrice+info.serviceFee) }}
              </span>
              <span v-show="info.pricingModel==2">
                ￥{{ (info.baseSalesPrice||0)+ (info.salePrice+info.serviceFee) }}
              </span>
              /人次
            </van-col>
          </van-row>
        </van-radio>
      </van-radio-group>
      <div class="list">
        <ld-button
          main
          size="md"
          @click.native="ensure"
        >
          确定
        </ld-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {Field,Cell ,ActionSheet,Grid, GridItem,Tag ,Popup,RadioGroup, Radio} from 'vant'
import { mapGetters } from 'vuex'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import City from 'Common/city'
import MescrollVue from 'mescroll.js/mescroll.vue'
import { localget, localset } from 'Utils/storage.js'

export default {
  name: 'GuestPass',
  components:{
    [Field.name]: Field,
    [Cell.name]: Cell,
    [ActionSheet.name]: ActionSheet,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    // tripType,
    ldTabbar,
    ldButton,
    City,
    MescrollVue,
  },
  data () {
    return {
      down:{use:false},
      showCardType:false,
      serverTypeData : [{value:'1',name:'接机服务'},{value:'2',name:'送机服务'}],
      serverType:'2',
      showFlightType:false,
      flightTypeData : [{value:'1',name:'国内航班'},{value:'2',name:'国际航班'}],
      flightType:'1',
      serverTypeName:'送机服务',
      flightTypeName:'国内航班',
      serviceData:[],
      cityName:'北京',
      serverAirportName:'首都国际机场',
      serverAirportCode:'PEK',
      showPopup:false,
      showList:false,//选择产品
      radio:'',
      guestsExplain:'暂无'
    }
  },
  computed: {
    ...mapGetters({
      // searchInfo: 'guestPass/searchInfo',
      detail: 'guestPass/detail',
    }),
  },
  created () {
    try {
      let historyLog=localget('_historyLog')||{}
      if(historyLog.guestPass){
        Object.assign(this,historyLog.guestPass)
      }
    } catch (error) {
      console.log(error)
    }
    // this.$api['restRoom/queryFacilities']({
    // 	'type': 2,
    // }).then(res=>{
    // 	let cache=res.data||{}
    // 	this.serviceData=cache.queryFacilitiesList||[]
    // })
    if(this.detail.length==0){
      this.query()
    }
  },
  methods:{
    showExplain(item){
      this.showPopup=true
      this.guestsExplain=item.guestsExplain
    },
    query(){
      if(this.serverAirportCode){
        this.$api['airService/guestPassQuery']({
          'threeCode': this.serverAirportCode,
          'serviceType': this.serverType,//1接机 2送机
          'flightType': this.flightType,//1国内 2国际
        }).then(res => {
          let cache=res.data||[]
          this.$store.commit('guestPass/setDetail',cache)
        })
      }
    },
    cityChange(info) {//城市回调  0国际 1 国内
      this.serverAirportName=info.jcZdName
      this.serverAirportCode=info.jcZdCode
      this.cityName=info.cityName
      if(info.international==0){
        this.flightType=2
      }else{
        this.flightType=1
      }
      this.query()
    },
    cardTypeSelect(item) {
      this.serverTypeName=item.name
      this.serverType=item.value
      this.showCardType=false
      this.query()
    },
    selFlightType(item) {
      this.flightTypeName=item.name
      this.flightType=item.value
      this.showFlightType=false
      this.query()
    },
    book(){
      if(this.detail.length==0){
        return
      }else if(this.detail.length==1){
        this.jump(this.detail[0])
      }else{
        this.showList=true
      }
    },
    confirm(index){
      this.jump(this.detail[index])
    },
    ensure(){
      this.jump(this.detail[this.radio])
    },
    jump(info){
      this.$store.commit('guestPass/searchInfo',info)
      let params={
        cityName: this.cityName,
        serverAirportName:this.serverAirportName,
        serverAirportCode:this.serverAirportCode,
        flightTypeName:this.flightTypeName,
        serverTypeName:this.serverTypeName,
        flightType:this.flightType,
        serverType:this.serverType,
      }
      this.$store.commit('guestPass/params',params)
      try {
        let historyLog=localget('_historyLog')||{}
        historyLog.guestPass=params
        localset('_historyLog',historyLog)
      } catch (error) {
        console.log(error)
      }
      this.$router.push({path:'/guestPass/confirm'})
    },
    toggle(name,params) {
      this.$refs[name].toggle(params)
    },
    //返回
    back() {
      this.$store.commit('guestPass/CLEAR_ALL')
      this.$router.push({path:'/home'})
    },
    getContainer(){
      return document.querySelector('.guestPass')
    }
  },
  watch: {
  }
}
</script>

<style lang="less" scoped>
@deep:~'>>>';
.guestPass{
    background-repeat: no-repeat;
    background-size: contain;
}
.top{
    padding-top: 100px;
}
.list{
    padding: 10px;
}
.box{
    padding-bottom: 5px;
}
.guestpasswrapper {
    height: calc(100vh - 96px);
    overflow: hidden;
}
@{deep}.van-radio__label{
    display: inline-block;
    width: 100%;
}
</style>
